import React from 'react';
import { Box, Spacer, Typography, Image, useTheme } from '@bcp-nextgen-dx-component-factory/accolade-design-system';
import { rem } from '@helpers';
import { Icons } from '@bcp-nextgen-dx-component-factory/accolade-design-system/dist/assets/MBCP';
import { FormatHelper } from '@bcp-channels-sharedcomponents-reactjs/core/dist/$helpers';
import { usePhonesModal } from '@store';

export const PhoneBadges: React.FC = () => {
	const { palette } = useTheme();
	const phonesModal = usePhonesModal();

	return (
		<>
			{phonesModal.map((contact, index) => (
				<Box
					key={`${contact.phone}_${index}`}
					styles={{
						alignItems: 'center',
						borderRadius: rem(100),
						backgroundColor: palette.background.b1,
						padding: `${rem(7.5)}${rem(16)}`,
					}}
				>
					<Box>
						<Image
							source={Icons.CallO}
							svgProps={{
								width: rem(16),
								height: rem(16),
								fill: palette.primary.p1,
							}}
						/>
					</Box>
					<Spacer horizontal={rem(8)} />
					<Box>
						<Typography appearance="body-75-04">
							{FormatHelper.formatPhoneNumber(contact.phone, false)}
						</Typography>
					</Box>
				</Box>
			))}
		</>
	);
};
